import { openDB } from 'idb';
import { createOrder } from './api';

const DB_NAME = 'food-system-db';
const STORE_NAME = 'pending-orders';

async function initDb() {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      db.createObjectStore(STORE_NAME, { keyPath: 'id', autoIncrement: true });
    },
  });
}

export async function addOrderToQueue(orderData) {
  const db = await initDb();
  await db.add(STORE_NAME, { timestamp: new Date().toISOString(), orderData });
  console.log('Order added to offline queue:', orderData);
}

export async function syncPendingOrders() {
  if (!navigator.onLine) {
    console.log('Offline. Cannot sync pending orders.');
    return;
  }

  const db = await initDb();
  let cursor = await db.transaction(STORE_NAME).store.openCursor();

  while (cursor) {
    const { id, orderData } = cursor.value;
    try {
      console.log('Attempting to sync order:', orderData);
      await createOrder(orderData); // Use the API function to send the order
      await db.delete(STORE_NAME, id);
      console.log('Order synced and removed from queue:', orderData);
    } catch (error) {
      console.error('Failed to sync order:', orderData, error);
      // If an order fails to sync, it remains in the queue for the next attempt.
      // You might want more sophisticated error handling here (e.g., retry limits).
      break; // Stop syncing if one fails to avoid hammering the server
    }
    cursor = await cursor.continue();
  }
}

// Setup event listeners for online/offline status
window.addEventListener('online', syncPendingOrders);
// Initial sync attempt when the app loads (in case it was offline previously)
syncPendingOrders();
